import globalData from "./FEU_DATA";

/**
 * The combined result of the default data and global data objects.
 */
export default Object.assign( {
    i18n: {
        dialogTitle: "Image Upload",
        dialogCancel: "Cancel",
        dialogClose: "Close",
        dialogUpload: "Upload",
        fileAllTooLarge: "The image exceeds the maximum size of %s.",
        fileAllTooLargePlural: "The images exceed the maximum size of %s.",
        fileSomeTooLarge: "An image exceeded the maximum size of %s.",
        fileSomeTooLargePlural: "Some images exceeded the maximum size of %s.",
        fileTooMany: "You can only upload %d image at a time.",
        fileTooManyPlural: "You can only upload %d images at a time.",
        fileRemove: "Remove",
        fileName: "File Name",
        fileType: "File Type",
        fileSize: "File Size",
        fileDimensions: "Dimensions",
        fieldCaption: "Caption",
        fieldDescription: "Description",
        fieldAlt: "Alt",
        fieldCustomUrl: "Custom Url",
        fieldCustomTarget: "Custom Target",
        restUploading: "Uploading images, please wait...",
        restBadResponse: "An unexpected response was received from the server.",
        restNetworkError: "An error occurred uploading the images.",
        resultSucceeded: "Uploaded",
        resultErrored: "Errored",
        resultSkipped: "Skipped"
    },
    rest: {
        endpoint: null,
        nonce: null
    },
    customTargets: [
        { value: "default", label: "Default" },
        { value: "_blank", label: "New Tab (_blank)" },
        { value: "_self", label: "Same Tab (_self)" }
    ]
}, globalData );